import React from 'react'
import {CSSTransitionGroup} from 'react-transition-group'

import Intro from './subcomponents/intro.js'
import Propertyselection from './subcomponents/propertyselection.js'
import Outro from './subcomponents/outro.js'
import Questions from './subcomponents/questions.js'

export default class QuestionsScreen extends React.Component{
	constructor(props) {
		super(props)
		this.state = {
			screenID: 0,
		}
	}

	setScreenID = () => {
		const {screenID} = this.state
		let newScreenID = screenID + 1
		this.setState({
			screenID: newScreenID,
		})
	}

	getScreen = () => {
		const {
			data,
			handler,
			setProperties,
			setPersonProperties,
			lang,
			name
		} = this.props
		const {screenID} = this.state
		let selectedData = data.screen_5
		switch(screenID){
		case 0:
			return(
				<Intro
					data={selectedData}
					setScreenID={this.setScreenID}
					setProperties={setPersonProperties}
				/>
			)
		case 1:
			return(
				<Propertyselection
					data={selectedData}
					setScreenID={this.setScreenID}
					setProperties={setProperties}
					name={name}
					lang={lang}
				/>
			)
		case 2: 
			return(
				<Outro
					data={selectedData}
					setScreenID={this.setScreenID}
				/>
			)
		case 3: 
			return(
				<Questions
					data={selectedData}
					handler={handler}
					name={name}
				/>
			)
		}
	}

	render(){
		const {data} = this.props
		const {screenID} = this.state
		let selectedData = data.screen_5.fields
		const duration = 1000

		return(
			<CSSTransitionGroup
				transitionName='slideup'
				transitionAppear={true}
				transitionAppearTimeout={duration}
				transitionEnterTimeout={duration}
				transitionLeaveTimeout={duration}>
				<div key={screenID} className='questionscreen'>
					{this.getScreen()}
				</div>
			</CSSTransitionGroup>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/questionsScreen.js